import { render } from "./VehicleInspectionAction.vue?vue&type=template&id=0453d587"
import script from "./VehicleInspectionAction.vue?vue&type=script&lang=js"
export * from "./VehicleInspectionAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__